import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngGridComponent } from './kng-grid.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { GridPagerService } from './kng-grid.service';
import { ActionButtonsComponent } from './action-buttons.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgxPaginationModule } from 'ngx-pagination';
@NgModule({
	declarations: [
		KngGridComponent, ActionButtonsComponent
	],
	imports: [ CommonModule, MatTableModule, MatPaginatorModule, MatSortModule, MatMenuModule, MatIconModule, MatButtonModule, NgxPaginationModule ],
	exports: [
		KngGridComponent
	],
	providers: [GridPagerService]
})
export class KngGridModule {}
